// Utility functions for movie-related operations

export const formatRuntime = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours}h ${mins}m`;
};

export const calculateSlotsNeeded = (runtime) => {
  return Math.ceil(runtime / 60);
};

// Generate hourly time slots from 8 PM to 2 AM, adjusted for timezone
export const generateTimeSlots = (timezone = 'ET') => {
  const timezoneOffsets = {
    'ET': 0,
    'CT': -1,
    'MT': -2,
    'PT': -3
  };
  
  const offset = timezoneOffsets[timezone] || 0;
  const slots = [];
  
  for (let hour = 20; hour <= 25; hour++) {
    const displayHour = hour > 23 ? hour - 24 : hour;
    const adjustedHour = displayHour + offset;
    const finalHour = adjustedHour < 0 ? adjustedHour + 24 : adjustedHour;
    
    const time = new Date();
    time.setHours(finalHour, 0, 0, 0);
    slots.push({
      id: `${hour}:00`,
      time: time.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        hour12: true 
      }),
      hour: displayHour,
      originalHour: hour,
      adjustedHour: finalHour
    });
  }
  
  const time2AM = new Date();
  const adjusted2AM = 2 + offset;
  const final2AM = adjusted2AM < 0 ? adjusted2AM + 24 : adjusted2AM;
  time2AM.setHours(final2AM, 0, 0, 0);
  slots.push({
    id: '26:00',
    time: time2AM.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      hour12: true 
    }),
    hour: 2,
    originalHour: 26,
    adjustedHour: final2AM
  });
  
  return slots;
};

export const groupDatesByWeek = (dates) => {
  if (dates.length === 0) return [];
  
  const firstDate = new Date(dates[0]);
  const dayOfWeek = firstDate.getDay();
  const firstSunday = new Date(firstDate);
  firstSunday.setDate(firstDate.getDate() - dayOfWeek);
  
  const lastDate = new Date(dates[dates.length - 1]);
  const lastDayOfWeek = lastDate.getDay();
  const lastSaturday = new Date(lastDate);
  lastSaturday.setDate(lastDate.getDate() + (6 - lastDayOfWeek));
  
  const weeks = [];
  const current = new Date(firstSunday);
  
  while (current <= lastSaturday) {
    const week = [];
    for (let i = 0; i < 7; i++) {
      week.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }
    weeks.push(week);
  }
  
  return weeks;
};

export const getWeekRange = (week) => {
  const start = week[0];
  const end = week[6];
  
  // Check if the week spans different years
  const startYear = start.getFullYear();
  const endYear = end.getFullYear();
  
  if (startYear !== endYear) {
    return `${start.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} - ${end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`;
  } else {
    // Same year, show year once at the end
    return `${start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${end.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}, ${startYear}`;
  }
};

export const getWeekTitle = (week, weekIndex) => {
  const start = week[0];
  const end = week[6];
  const startYear = start.getFullYear();
  const endYear = end.getFullYear();
  const currentYear = new Date().getFullYear();
  
  // Use actual date ranges instead of confusing week numbers
  if (startYear !== endYear) {
    // Week spans different years
    return `${start.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} - ${end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`;
  } else if (startYear !== currentYear) {
    // Different year from current
    return `${start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${end.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}, ${startYear}`;
  } else {
    // Current year
    return `${start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${end.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;
  }
};

export const generateDateRange = (startDateStr, endDateStr) => {
  // Parse dates with explicit timezone handling to avoid day-of-week shifts
  const startDate = new Date(startDateStr + 'T00:00:00');
  const endDate = new Date(endDateStr + 'T00:00:00');
  const dates = [];
  const current = new Date(startDate);
  
  while (current <= endDate) {
    dates.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }
  
  return dates;
};

